import { PropsWithChildren } from "react";

import { colors } from "#app/theme/v1/colors";
import { Paper } from "#shared/view/components/Paper";

import styles from "./QuoteRequestLine.module.css";

type Props = {
  quoteRequestLineId?: string;
  isParent?: boolean;
  isReliable?: boolean;
  isDetailsPanelDisplayable?: boolean;
  backgroundColor?: string;
};

export const QuoteRequestLineContainer = ({
  quoteRequestLineId,
  isReliable,
  isDetailsPanelDisplayable,
  children,
  backgroundColor = "",
}: PropsWithChildren<Props>) => {
  const getBackgroundColor = () => {
    if (isReliable) {
      return colors.green[1];
    }

    return backgroundColor;
  };

  return (
    <Paper
      key={quoteRequestLineId}
      withBorder
      mih={"87px"}
      p={"xs"}
      bg={getBackgroundColor()}
      className={`${styles.container!} ${isDetailsPanelDisplayable ? styles.hasCursorPointer! : ""}`}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {children}
    </Paper>
  );
};
